import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionalContext',
  props: {
    show: { type: Boolean, default: false },
    label: { default: undefined },
    additionalInfo: { default: undefined },
    background: { default: "main" },
    large: { type: Boolean, default: false },
    inset: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})